import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import { Button, Container, List } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../hooks/use-global-config';
import { GET_ALL_PROMOS, GET_PROMOS_BY_BRANCH } from '../../../enums/graphql';
import { CTA } from '../../';

import BranchDisclaimerModal from '../branch-offer/branch-disclaimer-modal';
import BranchOfferText from '../branch-offer/branch-offer-text';

const BranchPromoPanel = ({ branchID, fallback = {}, className, showNational = false, innerClassName, ...other }) => {
	const branchIdByType = Array.isArray(branchID) && branchID?.[0] ? branchID[0] : branchID;
	const [getNationalPromo, { data, loading, called }] = useLazyQuery(GET_ALL_PROMOS);
	const [getPromoByBranchId, { data: data2, loading: loading2, called: called2 }] = useLazyQuery(GET_PROMOS_BY_BRANCH, { variables: { branchIDs: branchIdByType } });
	const { showroom: configData } = useGlobalConfig();
	const [isOpen, setIsOpen] = useState(false);
	const [promoData, setPromoData] = useState(fallback);

	useEffect(() => {
		if (showNational) getNationalPromo();
		if (!showNational && branchIdByType?.length > 0) getPromoByBranchId();
	}, [showNational, branchIdByType, getNationalPromo, getPromoByBranchId]);

	useEffect(() => {
		if (!showNational || !called || loading) return;

		if (data?.getPromotions?.find((promo) => promo.national)) {
			setPromoData(data?.getPromotions?.find((promo) => promo.national));
		} else {
			getPromoByBranchId();
		}
	}, [showNational, called, loading, data, getPromoByBranchId]);

	useEffect(() => {
		if (!called2 || loading2) return;
		setPromoData(data2?.getPromotionsByBranchId?.[0]);
	}, [called2, loading2, data2]);

	const onModalTriggerClick = (value) => setIsOpen(value);

	if (!branchIdByType?.length) return null;

	return (
		<div
			className={`branchPromoPanel flex min-h-[375px] flex-col justify-center bg-black py-8 text-center xl:py-12 ${className || ''}`}
			data-testid='branch-promo-panel'
			{...other}
		>
			<Container>
				<div className={`branchPromoPanel-inner ${innerClassName || ''}`}>
					{configData?.promo_heading && <h2 className='mb-3 font-semibold text-white xl:mb-8'>{configData.promo_heading}</h2>}
					{(loading || loading2) && !promoData?.option1 && <p className='text-subtitle text-center text-white'>Loading promotion...</p>}
					{!loading && !loading2 && !promoData?.option1 && <p className='text-subtitle text-center text-white'>No current promotion at this time.</p>}

					<BranchOfferText offer={promoData} />

					{promoData?.option1 && (
						<List
							bullets='none'
							className='mt-4 flex flex-row flex-wrap max-md:space-y-3 md:justify-center md:space-x-4 xl:space-x-8'
						>
							{configData?.get_offer?.[0] && (
								<li className='flex-12/12 md:flex-none'>
									<CTA
										data={configData.get_offer[0]}
										className='text-white'
									/>
								</li>
							)}

							<li className='flex-12/12 md:flex-none'>
								<Button
									color='tertiary'
									onClick={() => onModalTriggerClick(true)}
									className='text-white'
								>
									{configData?.disclosure_modal}
								</Button>
							</li>
						</List>
					)}
				</div>

				<BranchDisclaimerModal
					isOpen={isOpen}
					onClose={() => onModalTriggerClick(false)}
					disclaimer={promoData}
				/>
			</Container>
		</div>
	);
};

BranchPromoPanel.propTypes = {
	branchID: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	fallback: PropTypes.object,
	className: PropTypes.string,
	showNational: PropTypes.bool,
	innerClassName: PropTypes.string,
};

export default BranchPromoPanel;
